import React, { useEffect, useRef } from "react";

export default function SiriWave() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const size = 100;
    canvas.width = size;
    canvas.height = size;

    let time = 0;

    const drawCircularWave = (radiusBase, amplitude, speed, color) => {
      ctx.beginPath();

      const centerX = size / 2;
      const centerY = size / 2;

      for (let angle = 0; angle <= Math.PI * 2; angle += 0.02) {
        const dynamicRadius =
          radiusBase + amplitude * Math.sin(angle * 6 + time * speed);

        const x = centerX + dynamicRadius * Math.cos(angle);
        const y = centerY + dynamicRadius * Math.sin(angle);

        if (angle === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
      }

      ctx.closePath();
      ctx.strokeStyle = color;
      ctx.lineWidth = 2;
      ctx.stroke();
    };

    const animate = () => {
      ctx.clearRect(0, 0, size, size);

      const center = size / 2;

      // clip circle
      ctx.save();
      ctx.beginPath();
      ctx.arc(center, center, center, 0, Math.PI * 2);
      ctx.clip();

      // dark base
      ctx.fillStyle = "#003049";
      ctx.fillRect(0, 0, size, size);

      // 360 waves (orb style)
      drawCircularWave(28, 4, 0.05, "#00c8ff");
      drawCircularWave(32, 5, 0.04, "#0077ff");
      drawCircularWave(24, 3, 0.06, "#33ddff");

      ctx.restore();

      time += 1;
      requestAnimationFrame(animate);
    };

    animate();
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backdropFilter: "blur(2px)",
        background: "rgba(0,0,0,0.3)",
        zIndex: 9998,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
      }}
    >
      <canvas
        ref={canvasRef}
        style={{
          borderRadius: "50%",
          boxShadow: "0 0 35px rgba(0,150,255,0.6)",
        }}
      />
    </div>
  );
}
